import { generateRoutes } from 'utils/generateRoutes';

export const grafanaSsoRoutes = generateRoutes({}, 'grafana-sso');
